export class CustomerModel {
  sellerCustomerId: number;
  buyerId: number;
  sellerId: number;
  firstname: string;
  lastname: string;
  companyName: string;
  contactNumber: string;
  notes: string;
  lastOfferAt: Date;
  offerCount: number;

  constructor(data: {
    sellerCustomerId: number;
    buyerId: number;
    sellerId: number;
    firstname: string;
    lastname: string;
    companyName: string;
    contactNumber: string;
    notes?: string;
    lastOfferAt: string;
    offerCount?: number;
  }) {
    this.sellerCustomerId = data.sellerCustomerId;
    this.buyerId = data.buyerId;
    this.sellerId = data.sellerId;
    this.firstname = data.firstname;
    this.lastname = data.lastname;
    this.companyName = data.companyName;
    this.contactNumber = data.contactNumber;
    this.notes = data.notes ?? '';
    this.lastOfferAt = typeof data.lastOfferAt === 'string' ? new Date(data.lastOfferAt) : data.lastOfferAt;
    this.offerCount = data.offerCount ?? 0;
  }
}
